import { BusinessUnitResolverBase } from './business-unit.resolver.base';
import { BusinessUnitService } from './business-unit.service';
import { Injectable } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class BusinessUnitResolver extends BusinessUnitResolverBase {

  constructor(protected service: BusinessUnitService) {
    super(service);
  }
}



